<template>
  <div class="dialog-container">
    <div class="btn" >
      <div @click="dialogClick">
        <!-- <i class="el-icon-upload2" style="padding-right: 5px"></i> -->
        <span>数据上传</span>
      </div>
    </div>
    <el-dialog
        class="transtant-input"
        :show-close="false"
        v-drag:common
        title="上传机型数据文件"
        :visible.sync="uploadDialog.visible"
        :append-to-body="true"
        width="550px"
        @close="cancelDialog()"
    >
      <el-form :rules="rule" :model="uploadDialog" ref="form">
        <el-form-item label="数据文件" label-width="120px" prop="fileInfo">
          <el-upload
              class="upload"
              ref="upload"
              accept=".xls,.xlsx"
              :action="action"
              name="file"
              :data="formHeader"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="onFileSelectChange"
              :http-request="onFileUpload"
              :on-success="onFileUploadSuccess"
              :on-error="onFileSelectError"
          >
            <el-input
                placeholder="请选择文件"
                readonly
                style="width: 260px"
                slot="trigger"
                :value="uploadDialog.fileInfo"
            ></el-input>
            <el-link
                underline
                style="margin-left: 10px; color: #1890ff; border-bottom: none;font-size;: 12px"
                target="blank"
                :href="downloadUrl"
                download
            >模板下载</el-link
            >
          </el-upload>
        </el-form-item>
        <!-- <el-form-item
            :rules="rule"
            label="用途"
            label-width="140px"
            prop="purpose"
        >
          <el-radio-group class="purpose-radio" v-model="purpose">
            <el-radio label="1">陆上</el-radio>
            <el-radio label="2">海上</el-radio>
            <el-radio label="3">共用</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item style="margin-bottom: 0;">
          <el-col :span="24" align="center" style="margin-bottom: 20px;">
            <el-button
                type="primary"
                @click="submitUpload()"
                :loading="uploadDialog.loading"
            >上 传</el-button>
            <el-button @click="cancelDialog()" type="info" id="quxiaobu1">取 消</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils';
// const apiKey = getToken();
const apiKey = 'test';
export default {
  props: {},
  name: 'uploader',
  data() {
    return {
      radio: '1',
      purpose: '1',
      action: `${process.env.VUE_APP_API_HOST}/windfarm/turbineType/uploadTurbineFile?apiKey=${apiKey}`,
       downloadUrl: `${process.env.VUE_APP_API_HOST}/windfarm/project/getTemplateFile?fileName=turbine.xlsx`,
     // downloadUrl: `${process.env.VUE_APP_API_HOST}/windfarm/turbineType/getTurbineTypeTemplateFile`,
      uploadDialog: {
        loading: false,
        visible: false,
        fileInfo: ''
      },
      rule: {
        fileInfo: [
          { required: true, message: '请上传文件', trigger: 'change' }
        ],
        purpose: [{ required: true, message: '请选择用途', trigger: 'change' }]
      }
    };
  },
  computed: {
    formHeader() {
      return {
        apiKey: getToken()
      };
    }
  },
  watch: {},
  methods: {
    dialogClick() {
      this.uploadDialog.visible = true;
      this.uploadDialog.loading = false;
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    },
    onFileSelectChange(val) {
      //console.log(val);
      this.uploadDialog.fileInfo = val.name;
    },
    onFileUpload(params) {
      const formData = new FormData();
      formData.append('purpose', this.purpose);
      formData.append('file', params.file);
      formData.append('apiKey', getToken());
      this.$fetch({
        url: '/windfarm/turbineType/uploadTurbineFile',
        method: 'POST',
        data: formData,
        responseType: 'blob',
        showLoading: true,
        noJudge: true
      })
          .then(res => {
            console.log(res);
            const blob = new Blob([res.data]);
            const reader = new FileReader();
            reader.readAsText(blob);
            console.log(reader);
            reader.onload = e => {
              console.log(e);
              this.onFileUploadSuccess(JSON.parse(reader.result));
            };
          })
          .catch(() => {
            this.uploadDialog.loading = false;
          });
    },
    onFileUploadSuccess(val) {
      this.uploadDialog.loading = false;
      this.uploadDialog.visible = false;
      this.purpose='1';
      if (this.$refs.form) {
        this.$refs.upload.clearFiles();
      }
      if (val.code === 0) {
        this.$store.commit('model/UPLOAD_SUCCESS', true);
        this.$message({
          message: val.message,
          type: 'success'
        });
      } else {
        this.$message({
          message: val.message,
          type: 'error'
        });
      }
    },
    onFileSelectError() {
      this.uploadDialog.visible = false;
      this.uploadDialog.loading = false;
      this.$message({
        message: '上传文件失败',
        type: 'error'
      });
    },
    submitUpload() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.uploadDialog.loading = true;
          this.$refs.upload.submit();
        }
      });
    },
    cancelDialog() {
      this.uploadDialog.visible = false;
      this.uploadDialog.loading = false;
      this.uploadDialog = {
        ...this.uploadDialog,
        fileInfo: '',
        vendor: '0'
      };
      if (this.$refs.form) {
        this.$refs.upload.clearFiles();
        this.$refs.form.clearValidate();
      }
    }
  }
};
</script>

<style lang="less" scoped>
#quxiaobu1{
  background-color: @white-color;
  border: 1px solid #dcdfe6;
  color: @black-color;
}
  /* #shujushangchaun{
    background-color: #081a29;
    width: 80px;
  } */
.dialog-container {
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
  }
  /deep/.el-dialog {
    .el-dialog__header {
      text-align: left;
     
    }
    .el-dialog__body {
      text-align: left;
      background-color: rgba(36, 45, 45, 0.8);
    }
    .import-button {
      margin-left: 20px;
    }
  }
}
/* test */
/deep/.el-input__inner {
  cursor: pointer;
}
.file-icon {
  font-size: 24px;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  vertical-align: middle;
}
/deep/.el-radio {
  color: #606266;
  .el-radio__label {
    color: #606266;
  }
}
</style>
